<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <div class="ion-padding">
    <div *ngIf="loadingDone == false">
      <ion-label>Loading in progress, please wait...</ion-label>
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    </div>

    <div *ngIf="loadingDone == true">
      <ion-item>
        <ion-label>Lesson Thumbnail</ion-label>
        <app-thumbnail
          *ngIf="LessonSettings?.LessonPictureContent_GUID"
          [(ngModel)]="LessonSettings.LessonPictureContent_GUID"
          description="Lesson Thumbnail"
        >
        </app-thumbnail>
        <ion-button
          (click)="onUploadContentClick($event,'LessonPictureContent_GUID',LessonSettings.LessonPictureContent_GUID,'Lesson Thumbnail')"
        >
          <ion-icon name="cloud-upload"></ion-icon>
          <ion-label>Upload</ion-label>
        </ion-button>
      </ion-item>
      <ion-item>
        <!-- <ion-label position="floating">Passrate : </ion-label> -->
        <ion-input
          value="{{LessonSettings?.Passrate}}"
          [(ngModel)]="LessonSettings.Passrate"
          label="Passrate :"
        ></ion-input>
      </ion-item>
      <ion-item>
        <!-- <ion-label position="floating">Max attempts : </ion-label> -->
        <ion-input
          value="{{LessonSettings?.MaxAttempts}}"
          [(ngModel)]="LessonSettings.MaxAttempts"
          label="Max attempts :"
        ></ion-input>
      </ion-item>
      <ion-item>
        <!-- <ion-label position="floating">Lesson validity (months) : </ion-label> -->
        <ion-input
          value="{{LessonSettings?.ValidityMonths}}"
          [(ngModel)]="LessonSettings.ValidityMonths"
          label="Lesson validity (months) :"
        ></ion-input>
      </ion-item>
      <ion-item>
        <!-- <ion-label position="floating">ERP\LMS lesson code : </ion-label> -->
        <ion-input
          value="{{LessonSettings?.SAPCode}}"
          [(ngModel)]="LessonSettings.SAPCode"
          label="ERP\LMS lesson code :"
        ></ion-input>
      </ion-item>
      <ion-item>
        <ion-label>Active</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.IsActive"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label>Induction</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.IsInduction"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label>Randomised</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.IsRandomised"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label>Allow learning</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.AllowLearning"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label>Is survey</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.IsSurvey"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label>Skip question review</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.SkipQuestionReview"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-label>Skip audio feedback</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.SkipAudioFeedback"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <!-- <ion-item>
        <ion-label>Show Lesson Content</ion-label>
        <ion-checkbox
          slot="start"
          [(ngModel)]="LessonSettings.ShowLessonContent"
          [ngModelOptions]="{standalone: true}"
        ></ion-checkbox>
      </ion-item>
      <br /> -->
      <br />
      <ion-row>
        <ion-col class="modal-ion-col-bottom-buttons" style="left: 0">
          <ion-button
            (click)="onCloseUpload()"
            class="menuitem-ion-button"
            style="width: 110% !important; left: 0"
            >Close</ion-button
          >
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
